import * as tslib_1 from "tslib";
import { CredentialStoreResourceType, } from '@models';
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { CredentialStoresService, } from '@services';
import * as i0 from "@angular/core";
import * as i1 from "../../../services/credential-stores.service";
var AssetCredentialStoreResourcesSource = /** @class */ (function () {
    function AssetCredentialStoreResourcesSource(_credentialStore) {
        this._credentialStore = _credentialStore;
    }
    Object.defineProperty(AssetCredentialStoreResourcesSource.prototype, "mapper", {
        get: function () {
            return this._credentialStore.mapper;
        },
        enumerable: true,
        configurable: true
    });
    AssetCredentialStoreResourcesSource.prototype.get = function (qo) {
        return this._credentialStore.getResourcesForCredentialStore(this.credentialStore, CredentialStoreResourceType.AssetCredential, qo);
    };
    AssetCredentialStoreResourcesSource.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AssetCredentialStoreResourcesSource_Factory() { return new AssetCredentialStoreResourcesSource(i0.ɵɵinject(i1.CredentialStoresService)); }, token: AssetCredentialStoreResourcesSource, providedIn: "root" });
    return AssetCredentialStoreResourcesSource;
}());
export { AssetCredentialStoreResourcesSource };
var AssetCredentialStoreResourcesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AssetCredentialStoreResourcesComponent, _super);
    function AssetCredentialStoreResourcesComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AssetCredentialStoreResourcesComponent;
}(ODataGridComponent));
export { AssetCredentialStoreResourcesComponent };
